// removed by extract-text-webpack-plugin
module.exports = {"container":"src-pages-__SearchResult-module___container","filterRow":"src-pages-__SearchResult-module___filterRow","resultCount":"src-pages-__SearchResult-module___resultCount","filterButton":"src-pages-__SearchResult-module___filterButton","icon":"src-pages-__SearchResult-module___icon","iconText":"src-pages-__SearchResult-module___iconText","active":"src-pages-__SearchResult-module___active"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/SearchResult.module.css
// module id = 685
// module chunks = 0